export enum SearchResultSlideType {
  RESTAURANT = 'RESTAURANT',
  CHAIN = 'CHAIN',
  DIVIDER = 'DIVIDER',
}
